import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SubjectType } from '../../../../financial/data/interfaces/price-agreement';
import { ExpiringAgreement } from '../types';

@Component({
  selector: 'dashboard-price-agreements-expire-list',
  templateUrl: './expire-list.component.html',
  styleUrls: ['./expire-list.component.scss']
})
export class DashboardPriceAgreementsExpireListComponent {
  @Input() agreements: ExpiringAgreement[] = [];

  readonly SubjectType = SubjectType;

  constructor(private Router: Router) { }

  get sortedAgreements(): ExpiringAgreement[] {
    return [...this.agreements]
      .sort((left, right) => left.daysUntilExpiration - right.daysUntilExpiration);
  }

  showSubject(agreement: ExpiringAgreement): void {
    const route = agreement.subjectType === SubjectType.Project
      ? ['projects', agreement.subjectId]
      : ['customers', 'details', agreement.subjectId];

    this.Router.navigate(route);
  }

  showPriceAgreements(): void {
    this.Router.navigateByUrl('settings/financial/price-agreements');
  }

  getUrgencyClass(daysUntilExpiration: number): string {
    if(daysUntilExpiration <= 7)
      return 'bg-danger';

    if(daysUntilExpiration <= 14)
      return 'bg-warning';

    return 'bg-secondary';
  }

  trackByAgreementId(_index: number, agreement: ExpiringAgreement): number {
    return agreement.id;
  }
}
